import {gsap} from "gsap";
import {ReelView} from "../../../core/reel/simplereel/SimpleReelModel";
import {NineToFive} from "../../NineToFive";
import {NineToFiveGameAssets} from "../../NineToFiveGameAssets";
import {NineToFiveSymbol, SymbolArgs} from "./NineToFiveSymbol";
import {NineToFiveStatics} from "../../config/NineToFiveStatics";
import {SpineGSAPWrapper} from "../../animation/SpineGSAPWrapper";
import {GameMode} from "@nolimit/slot-game/bin/flowcontrol/GameMode";

export class LawSuitSymbol extends NineToFiveSymbol {

    constructor(args:SymbolArgs) {
        if (NineToFive.model.data.mode == GameMode.FREESPIN_SUPER) {
           args.suffix = "_Reset" ;
        }
        super(args);
    }

    public minusOne():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "MN_Win"))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }

    public reset():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                this.winAnimation.alpha = 1;
                this.moveToWinLayer();
            })
            .add(SpineGSAPWrapper.createTimeline(this.winAnimation, 0, "MN_Reset_Win"))
            .add(() => {
                this.winAnimation.alpha = 0;
                this.moveToNormalLayer();
            });
    }
}

